import React from 'react';
import {useSelector} from 'react-redux';

import {offersApiSelectorFn} from '../redux/selectors';

import OfferCarouselUI from '../../../../stories/components/hotels/HomePage/OfferCarouselUI/OfferCarouselUI';
import OfferCarouselLoader from '../../../../stories/components/hotels/HomePage/OfferCarouselLoader/OfferCarouselLoader';


const OfferCarousel = () => {
  const {data: offersDataFromState, isLoading: isOffersCarouselLoading} = useSelector(
    offersApiSelectorFn,
  );

  const actionHandler = item => {
    window.open(item);
  };

  if (isOffersCarouselLoading)
    return <OfferCarouselLoader />;

  if (!offersDataFromState || offersDataFromState.length === 0) return null;

  return (
    <OfferCarouselUI
      dataFromState={offersDataFromState}
      actionHandler={actionHandler}
    />
  );
};

export default OfferCarousel;
